// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkout_main__KnuqP {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 8rem;
}
@media only screen and (max-width: 31.25em) {
  .Checkout_main__KnuqP {
    padding: 3rem 4rem;
  }
}

.Checkout_business__VGjB3 {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  width: 75vw;
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  color: var(--color-primary);
}
.Checkout_business__VGjB3 img {
  width: 5rem;
  margin-right: 2rem;
  font-size: 1.8rem;
}

.Checkout_product__o6vLJ {
  background-color: var(--color-white);
  border-radius: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  display: grid;
  grid-template-columns: 40rem 1fr;
  padding: 4rem;
  gap: 3rem;
}
@media only screen and (max-width: 43.75em) {
  .Checkout_product__o6vLJ {
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 31.25em) {
  .Checkout_product__o6vLJ {
    padding: 2rem;
  }
}
.Checkout_product__images_main__mXWJ- {
  width: 100%;
  border-radius: 2rem;
  margin-bottom: 2rem;
}
.Checkout_product__images_main2__ISX4e {
  width: 100%;
  border-radius: 2rem;
  margin-bottom: 2rem;
}
.Checkout_product__images_main2__ISX4e img {
  width: 100%;
  height: 40rem;
  object-fit: cover;
  border-radius: 2rem;
}
.Checkout_product__images_crumbs__NSmUi {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
.Checkout_product__images_crumbs__NSmUi img {
  object-fit: cover;
  width: 100%;
  height: 15vh;
  border-radius: 2rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.Checkout_product__images_crumbs__active__uDZbL {
  border: 2px solid var(--color-primary);
}
.Checkout_product__desc__7U\\+5B {
  width: 100%;
  align-self: center;
}
.Checkout_product__desc_amt__5qOW2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  border-radius: 1.5rem;
  background-color: var(--color-grey-3);
  font-weight: 700;
  width: fit-content;
  color: var(--color-primary);
}
.Checkout_product__desc_beside__Wpgg4 {
  display: flex;
  margin-bottom: 2rem;
}
.Checkout_product__desc_beside__Wpgg4 > :not(:last-child) {
  margin-right: 1rem;
}

.Checkout_mima__fsjyQ {
  display: flex;
  align-items: center;
  margin-top: 3rem;
}
.Checkout_mima__fsjyQ > :not(:last-child) {
  margin-right: 1rem;
}
.Checkout_mima__logo__bHzAK {
  height: 3rem;
}

.Checkout_order__OHYoq {
  margin-bottom: 2rem;
}
.Checkout_order__top__kuGPM {
  display: flex;
  margin-bottom: 2rem;
  gap: 2rem;
}
.Checkout_order__top__kuGPM > :first-child {
  font-size: 3.5rem;
  margin-right: 3rem;
  cursor: pointer;
}
.Checkout_order__top__kuGPM > :first-child:hover {
  color: var(--color-primary);
}
.Checkout_order__customer__lEmJV {
  width: 100%;
  border-radius: 2rem;
  padding: 2rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid var(--color-grey);
}
@media only screen and (max-width: 31.25em) {
  .Checkout_order__customer__lEmJV {
    padding: 0;
    border: none;
    margin: auto;
  }
}
.Checkout_order__summary__p2gfc {
  padding: 3rem;
  background-color: var(--color-white);
  margin-top: 3rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 2rem;
}
.Checkout_order__summary__p2gfc span {
  font-weight: 700;
  color: var(--color-primary);
}
.Checkout_order__summary__p2gfc table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  margin-top: 2rem;
  font-size: 1.4rem;
}
.Checkout_order__summary__p2gfc table tr {
  padding: 0 1rem;
  align-items: center;
  font-weight: 700;
}
.Checkout_order__summary__p2gfc table tr:not(:last-child) {
  border-bottom: 1px solid var(--color-grey);
}
.Checkout_order__summary__p2gfc table tr > :first-child {
  width: 50%;
}
.Checkout_order__summary__p2gfc table tr > :last-child {
  text-align: right;
}
.Checkout_order__summary__p2gfc table th,
.Checkout_order__summary__p2gfc table td {
  padding: 1.2rem 2rem;
}
.Checkout_order__summary__p2gfc table th {
  font-weight: 700;
}
.Checkout_order__summary__p2gfc table thead {
  margin-bottom: 2rem;
  border-bottom: 1px solid var(--color-grey);
}
.Checkout_order__summary_location__fgR3A {
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  line-height: 1.5rem;
}
.Checkout_order__summary_location__fgR3A span {
  display: flex;
  text-align: left;
  font-weight: 400;
}
.Checkout_order__summary_location__fgR3A > :not(:last-child) {
  margin-bottom: 2rem;
}

.Checkout_variations__3OOIn {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
}
@media only screen and (max-width: 56.25em) {
  .Checkout_variations__3OOIn {
    justify-content: center;
    align-items: center;
    justify-content: flex-start;
  }
}
.Checkout_variations_variation__35FIu {
  font-size: 1.3rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.Checkout_variations_selectedVariation__BhWam {
  font-size: 1.3rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  color: var(--color-white);
  font-weight: 700;
  background-color: var(--color-dark);
  margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Inventory/Checkout.module.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AADD;AAEC;EAND;IAOE,kBAAA;EACA;AACF;;AAEA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,gBAAA;EACA,2BAAA;AACD;AACC;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAGA;EACC,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,gCAAA;EAEA,aAAA;EACA,SAAA;AADD;AAEC;EATD;IAUE,2BAAA;EACA;AACF;AACC;EAbD;IAcE,aAAA;EAEA;AACF;AAME;EACC,WAAA;EACA,mBAAA;EACA,mBAAA;AAJH;AAWE;EACC,WAAA;EACoB,mBAAA;EACpB,mBAAA;AARH;AAUG;EACC,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AARJ;AAaE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAXH;AAaG;EACC,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAXJ;AAcG;EACC,sCAAA;AAZJ;AAiBC;EACC,WAAA;EACA,kBAAA;AAfF;AAiBE;EACC,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAhBH;AAmBE;EACC,aAAA;EAEA,mBAAA;AAlBH;AAmBG;EACC,kBAAA;AAjBJ;;AAuBA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AApBD;AAsBC;EACC,kBAAA;AApBF;AAuBC;EACC,YAAA;AArBF;;AAyBA;EACC,mBAAA;AAtBD;AAwBC;EACC,aAAA;EAEA,mBAAA;EACA,SAAA;AAvBF;AAyBE;EACC,iBAAA;EACA,kBAAA;EACA,eAAA;AAvBH;AAyBG;EACC,2BAAA;AAvBJ;AA4BC;EACC,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;AA5BF;AA8BE;EAZD;IAaE,UAAA;IACA,YAAA;IACA,YAAA;EA3BD;AACF;AA8BC;EAEC,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,mBAAA;AA7BF;AA+BE;EACC,gBAAA;EACA,2BAAA;AA7BH;AAgCE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AA9BH;AAgCG;EACC,eAAA;EACA,mBAAA;EACA,gBAAA;AA9BJ;AAgCI;EACC,0CAAA;AA9BL;AAiCI;EACC,UAAA;AA/BL;AAkCI;EACC,iBAAA;AAhCL;AAoCG;;EAEC,oBAAA;AAlCJ;AAqCG;EACC,gBAAA;AAnCJ;AAsCG;EACC,mBAAA;EACA,0CAAA;AApCJ;AAkDE;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAhDH;AAkDG;EACC,aAAA;EACA,gBAAA;EACA,gBAAA;AAhDJ;AAmDG;EACC,mBAAA;AAjDJ;;AAuDA;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AApDD;AAsDC;EAND;IAOG,uBAAA;IACA,mBAAA;IAID,2BAAA;EAvDA;AACF;AAyDC;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAlDH;AAqDC;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;AAnDH","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\twidth: 100vw;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 3rem 8rem;\n\t@media only screen and (max-width: $bp-500) {\n\t\tpadding: 3rem 4rem;\n\t}\n}\n\n.business {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-bottom: 2rem;\n\twidth: 75vw;\n\tfont-size: var(--default-font-subtitle);\n\tfont-weight: 700;\n\tcolor: var(--color-primary);\n\n\timg{\n\t\twidth: 5rem;\n\t\tmargin-right: 2rem;\n\t\tfont-size: 1.8rem;\n\t}\n}\n\n.product {\n\tbackground-color: var(--color-white);\n\tborder-radius: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tdisplay: grid;\n\tgrid-template-columns: 40rem 1fr;\n\t// box-sizing: border-box;\n\tpadding: 4rem;\n\tgap: 3rem;\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tpadding: 2rem;\n\t}\n\n\t\n\n\t&__images {\n\t\t// display: flex;\n\t\t// flex-direction: column;\n\n\t\t&_main {\n\t\t\twidth: 100%;\n\t\t\tborder-radius: 2rem;\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\t// @media only screen and (max-width: $bp-400) {\n\t\t\t// \theight: 45vh;\n\t\t\t// }\n\t\t}\n\n\t\t&_main2 {\n\t\t\twidth: 100%;\n\t\t\tborder-radius: 2rem;border-radius: 2rem;\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 40rem;\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: 2rem;\n\t\t\t}\t\n\t\t}\n\n\n\t\t&_crumbs {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t\tgap: 1rem;\n\n\t\t\timg {\n\t\t\t\tobject-fit: cover;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 15vh;\n\t\t\t\tborder-radius: 2rem;\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&__active {\n\t\t\t\tborder: 2px solid var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__desc {\n\t\twidth: 100%;\n\t\talign-self: center;\n\n\t\t&_amt {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\n\t\t\tjustify-content: center;\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1.5rem;\n\t\t\tbackground-color: var(--color-grey-3);\n\t\t\tfont-weight: 700;\n\t\t\twidth: fit-content;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&_beside {\n\t\t\tdisplay: flex;\n\t\t\t// align-items: center;\n\t\t\tmargin-bottom: 2rem;\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mima {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 3rem;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__logo {\n\t\theight: 3rem;\n\t}\n}\n\n.order {\n\tmargin-bottom: 2rem;\n\n\t&__top {\n\t\tdisplay: flex;\n\n\t\tmargin-bottom: 2rem;\n\t\tgap: 2rem;\n\n\t\t& > :first-child {\n\t\t\tfont-size: 3.5rem;\n\t\t\tmargin-right: 3rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__customer {\n\t\twidth: 100%;\n\t\t// background-color: var(--color-white);\n\t\tborder-radius: 2rem;\n\t\t// box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tpadding: 2rem;\n\t\tmargin-bottom: 2rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tborder: 2px solid var(--color-grey);\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tpadding: 0;\n\t\t\tborder: none;\n\t\t\tmargin: auto;\n\t\t}\n\t}\n\n\t&__summary {\n\t\t// width: 75%;\n\t\tpadding: 3rem;\n\t\tbackground-color: var(--color-white);\n\t\tmargin-top: 3rem;\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 2rem;\n\n\t\tspan {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\t\t\tmargin-top: 2rem;\n\t\t\tfont-size: 1.4rem;\n\n\t\t\ttr {\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\t\t\t\tfont-weight: 700;\n\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tborder-bottom: 1px solid var(--color-grey);\n\t\t\t\t}\n\n\t\t\t\t& > :first-child {\n\t\t\t\t\twidth: 50%;\n\t\t\t\t}\n\n\t\t\t\t& > :last-child {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 1.2rem 2rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\tthead {\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t\tborder-bottom: 1px solid var(--color-grey);\n\t\t\t}\n\n\t\t\t// tbody {\n\t\t\t//     tr {\n\t\t\t//         background-color: var(--color-white);\n\n\t\t\t//         &:nth-child(even) {\n\t\t\t//             background-color: var(--color-table-grey);\n\t\t\t//         }\n\t\t\t//     }\n\t\t\t// }\n\t\t}\n\n\t\t&_location {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tfont-size: 1.2rem;\n\t\t\tline-height: 1.5rem;\n\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t\ttext-align: left;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.variations {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 10px;\n\tmargin: 20px 0;\n  \n\t@media only screen and (max-width: $bp-900) {\n\t  justify-content: center;\n\t  align-items: center;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tjustify-content: flex-start;\n\t  }\n  \n\t&_variation {\n\t  font-size: 1.3rem;\n\t  padding: 0.5rem;\n\t  border: 1px solid var(--color-dark);\n\t  border-radius: 0.8rem;\n\t  cursor: pointer;\n\t  margin-bottom: 1rem;\n\t}\n  \n\t&_selectedVariation {\n\t  font-size: 1.3rem;\n\t  padding: 0.5rem;\n\t  border: 1px solid var(--color-dark);\n\t  border-radius: 0.8rem;\n\t  cursor: pointer;\n\t  color: var(--color-white);\n\t  font-weight: 700;\n\t  background-color: var(--color-dark);\n\t  margin-bottom: 1rem;\n\t}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Checkout_main__KnuqP`,
	"business": `Checkout_business__VGjB3`,
	"product": `Checkout_product__o6vLJ`,
	"product__images_main": `Checkout_product__images_main__mXWJ-`,
	"product__images_main2": `Checkout_product__images_main2__ISX4e`,
	"product__images_crumbs": `Checkout_product__images_crumbs__NSmUi`,
	"product__images_crumbs__active": `Checkout_product__images_crumbs__active__uDZbL`,
	"product__desc": `Checkout_product__desc__7U+5B`,
	"product__desc_amt": `Checkout_product__desc_amt__5qOW2`,
	"product__desc_beside": `Checkout_product__desc_beside__Wpgg4`,
	"mima": `Checkout_mima__fsjyQ`,
	"mima__logo": `Checkout_mima__logo__bHzAK`,
	"order": `Checkout_order__OHYoq`,
	"order__top": `Checkout_order__top__kuGPM`,
	"order__customer": `Checkout_order__customer__lEmJV`,
	"order__summary": `Checkout_order__summary__p2gfc`,
	"order__summary_location": `Checkout_order__summary_location__fgR3A`,
	"variations": `Checkout_variations__3OOIn`,
	"variations_variation": `Checkout_variations_variation__35FIu`,
	"variations_selectedVariation": `Checkout_variations_selectedVariation__BhWam`
};
export default ___CSS_LOADER_EXPORT___;
